import React, { Component } from "react";
import {
  Box,
  Button,
  TextInput,
  TextArea,
  List,
  Layer,
  Heading,
  FormField,
  Text,
  RadioButtonGroup,
  Spinner,
  CheckBox,
} from "grommet";
import { callApiGetJson, callApiPostJson } from "./GlobalSettings";
import auth from "./Security/Auth";
import {
  Add,
  Trash,
  FormDown,
  FormUp,
  Configure,
  FormCheckmark,
  SearchAdvanced,
  Copy,
  Close,
} from "grommet-icons";
import Alert from "@material-ui/lab/Alert";
import { CopyToClipboard } from "react-copy-to-clipboard";

class VoucherPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailInput: "",
      emailList: [],
      errorMessage: "",
      duration: 5,
      // New state variables for API integration
      demoOptions: [],
      selectedDemoId: "",
      isLoadingDemos: true,
      demoError: "",
      opportunityId: "",
      voucherdescription: "",
      noOpportunityId: false,
      isOppIdValid: null, // null = unvalidated, true = green, false = red
      isValidatingOpp: false,
      bAlertOnSubmit: false,
      AlertMsg: "",
      bsubmitLoader: false,
      voucher_code: "",
      copied: false,
    };
  }

  // Fetch demos automatically when the component mounts
  componentDidMount() {
    this.fetchDemos();
  }

  fetchDemos = async () => {
    try {
      // SUCCESS: callApiGetJson automatically handles 'APIServerURL + endpoint' internally!
      const data = await callApiGetJson(
        "/PhysicalContent/GetVoucherEnabledDemos",
      );

      if (!data || !Array.isArray(data)) {
        throw new Error("Invalid or empty data format received");
      }

      // Filter out null IDs and map properties to Grommet format
      const formattedOptions = data
        .filter((demo) => demo.Demo_ID !== null)
        .map((demo) => ({
          label: (
            <Text>
              {demo.Demo_Title}
              {"     "}
              <Text weight="bold" color="brand">
                ( Demo ID: {demo.Demo_ID} )
              </Text>
            </Text>
          ),
          value: demo.Demo_ID,
        }));

      this.setState({
        demoOptions: formattedOptions,
        // Pre-select the first valid item if available
        selectedDemoId:
          formattedOptions.length > 0 ? formattedOptions[0].value : "",
        isLoadingDemos: false,
      });
    } catch (error) {
      console.error("Error loading demo options:", error);
      this.setState({
        demoError: "Could not load demo options.",
        isLoadingDemos: false,
      });
    }
  };

  handleInputChange = (event) => {
    this.setState({
      emailInput: event.target.value,
      errorMessage: "",
    });
  };

  // Handler for Opportunity ID text field
  handleOppIdChange = (event) => {
    this.setState({
      opportunityId: event.target.value,
      isOppIdValid: null, // Reset validation status immediately when user edits the text
    });
  };

  handleVoucherDescription(val) {
    if (val != undefined) {
      console.log("Voucher Description is - ", val);
      this.setState({ voucherdescription: val });
    }
  }

  handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    this.setState({
      noOpportunityId: isChecked,
      opportunityId: isChecked ? "" : this.state.opportunityId,
      isOppIdValid: isChecked ? null : this.state.isOppIdValid, // Reset status if checking the box
    });
  };

  // Click handler for the gear icon button to run the check
  handleValidateOpportunity = async () => {
    const { opportunityId } = this.state;
    if (!opportunityId.trim()) return;

    this.setState({ isValidatingOpp: true });

    try {
      let token = auth.getToken();
      const data = await callApiGetJson(
        `/SFDC/GetSFDCValidation?OptyId=${encodeURIComponent(opportunityId.trim())}`,
        token,
      );

      // Condition: operational response check + non-null key check
      if (
        data !== undefined &&
        data !== null &&
        data.SRC_OPTY_SHRT_UID != null
      ) {
        this.setState({ isOppIdValid: true, isValidatingOpp: false });
      } else {
        this.setState({ isOppIdValid: false, isValidatingOpp: false });
      }
    } catch (error) {
      console.error("Error validating Opportunity ID:", error);
      this.setState({ isOppIdValid: false, isValidatingOpp: false });
    }
  };

  handleDurationChange = (event) => {
    const val = event.target.value.replace(/[^0-9]/g, "");
    if (val === "") {
      this.setState({ duration: "" });
      return;
    }
    const parsedVal = parseInt(val, 10);
    this.setState({ duration: Math.min(7, Math.max(1, parsedVal)) });
  };

  incrementDuration = () => {
    this.setState((prevState) => ({
      duration: Math.min(10, (prevState.duration || 0) + 1),
    }));
  };

  decrementDuration = () => {
    this.setState((prevState) => ({
      duration: Math.max(5, (prevState.duration || 1) - 1),
    }));
  };

  handleAddEmail = () => {
    const { emailInput, emailList } = this.state;
    const trimmedEmail = emailInput.trim();
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!trimmedEmail) {
      this.setState({ errorMessage: "Email field cannot be empty." });
      return;
    }
    if (!emailRegex.test(trimmedEmail)) {
      this.setState({
        errorMessage: "Please enter a valid email address structure.",
      });
      return;
    }
    if (emailList.includes(trimmedEmail)) {
      this.setState({ errorMessage: "This email address is already added." });
      return;
    }
    this.setState({
      emailList: [...emailList, trimmedEmail],
      emailInput: "",
      errorMessage: "",
    });
  };

  handleRemoveEmail = (indexToRemove) => {
    this.setState((prevState) => ({
      emailList: prevState.emailList.filter(
        (_, index) => index !== indexToRemove,
      ),
    }));
  };

  handleDemoChange = (event) => {
    this.setState({ selectedDemoId: event.target.value });
  };

  setClose = () => {
    this.setState({ bAlertOnSubmit: false, AlertMsg: "" });
    this.props.onClose();
  };

  handleSubmit = async () => {
    const {
      emailList,
      duration,
      selectedDemoId,
      opportunityId,
      voucherdescription,
      noOpportunityId,
    } = this.state;

    var endpoint = "/Events/create_voucher";
    var token = auth.getToken();
    this.setState({ bsubmitLoader: true });

    let req_payload = {
      emailList: emailList,
      duration: duration || 1,
      demoId: selectedDemoId,
      opportunityId: noOpportunityId ? "NONE" : opportunityId,
      voucherdescription: voucherdescription,
    };

    try {
      callApiPostJson(endpoint, req_payload, token).then((response) => {
        console.log("Response: Voucher Creation ", JSON.stringify(response));
        if (response && response.voucher_created && response.emailSent) {
          this.setState({
            bAlertOnSubmit: true,
            emailList: [],
            selectedDemoId: "",
            opportunityId: "",
            voucherdescription: "",
            duration: 1,
            voucher_code: response.voucher_code,
            //bsubmitLoader: false,
            AlertMsg:
              "Voucher creation successful (Emails sent). Voucher Code is : " +
              response.voucher_code +
              " (Please save/copy code and share to redeem)",
          });
          // logAccess(
          //   this.props.demo.Content_ID,
          //   this.props.demo.Content_Type,
          //   "On-Demand",
          //   this.props.calledBy,
          //   auth.getToken(),
          // );
        } else if (
          response &&
          !response.voucher_created &&
          !response.emailSent
        ) {
          this.setState({
            bAlertOnSubmit: true,
            emailList: [],
            selectedDemoId: "",
            opportunityId: "",
            voucherdescription: "",
            duration: 1,
            //bsubmitLoader: false,
            AlertMsg: "Voucher creation failed. Contact Demo Portal Team.",
          });
          //alert('Same Demo Event Already running....');
        } else if (
          response &&
          response.voucher_created &&
          !response.emailSent
        ) {
          this.setState({
            bAlertOnSubmit: true,
            emailList: [],
            selectedDemoId: "",
            opportunityId: "",
            voucherdescription: "",
            duration: 1,
            voucher_code: response.voucher_code,
            //bsubmitLoader: false,
            AlertMsg:
              "Voucher creation is successful (Without Emails). Voucher Code is : " +
              response.voucher_code +
              " (Please save/copy code and share to redeem)",
          });
          //alert('Same Demo Event Already running....');
        }
      });
    } catch (error) {
      this.setState({
        bAlertOnSubmit: true,
        emailList: [],
        selectedDemoId: "",
        opportunityId: "",
        voucherdescription: "",
        duration: 1,
        // bsubmitLoader: false,
        AlertMsg: "Voucher creation failed. Contact Demo Portal Support",
      });
      console.error("Error submitting payload:", error);
    }
  };

  render() {
    const {
      emailInput,
      emailList,
      errorMessage,
      duration,
      demoOptions,
      selectedDemoId,
      isLoadingDemos,
      demoError,
      opportunityId,
      voucherdescription,
      noOpportunityId,
      isOppIdValid,
      isValidatingOpp,
      bAlertOnSubmit,
      AlertMsg,
      bsubmitLoader,
      voucher_code,
      copied,
    } = this.state;
    const { onClose } = this.props;

    let AltStatus = null;
    if (bAlertOnSubmit === true && AlertMsg !== "") {
      if (AlertMsg.includes("sent")) {
        AltStatus = (
          <Box
            align="end"
            //justify="between"
            direction="row"
            gap="medium"
            fill="horizontal"
            justify="end"
            //alignSelf="end"
          >
            <Box align="start" justify="start" direction="row">
              <Alert severity="success">{AlertMsg}</Alert>
            </Box>
            <CopyToClipboard
              text={voucher_code}
              onCopy={() => this.setState({ copied: true })}
            >
              <Button
                icon={<Copy />}
                label={copied ? "copied" : "copy voucher-code"}
                secondary
                disabled={copied}
                // onClick={}
              />
            </CopyToClipboard>
          </Box>
        );
      } else if (AlertMsg.includes("Without")) {
        AltStatus = (
          <Box
            align="end"
            //justify="between"
            direction="row"
            gap="medium"
            fill="horizontal"
            justify="end"
            //alignSelf="end"
          >
            <Box align="start" justify="start" direction="row">
              <Alert severity="warning">{AlertMsg}</Alert>
            </Box>
            <CopyToClipboard
              text={voucher_code}
              onCopy={() => this.setState({ copied: true })}
            >
              <Button
                icon={<Copy />}
                label={copied ? "copied" : "copy voucher-code"}
                secondary
                disabled={copied}
                // onClick={}
              />
            </CopyToClipboard>
          </Box>
        );
      } else if (AlertMsg.includes("failed")) {
        AltStatus = (
          <Box align="start" justify="start" direction="row">
            <Alert severity="error">{AlertMsg}</Alert>
          </Box>
        );
      }
    }

    // Determine the color of the gear configuration icon dynamically
    let iconColor = "dark-3"; // Default gray color
    if (isOppIdValid === true) iconColor = "status-ok"; // Grommet green template theme color
    if (isOppIdValid === false) iconColor = "status-critical"; // Grommet red template theme color

    // Enforce submission validity constraints
    const isOppIdSectionValid = noOpportunityId || isOppIdValid === true;
    const isFormInvalid =
      emailList.length === 0 || !selectedDemoId || !isOppIdSectionValid;

    let validationMessage = null;
    if (isOppIdValid === true) {
      validationMessage = (
        <Text color="status-ok" size="small">
          (Opp. ID successfully validated)
        </Text>
      );
    } else if (isOppIdValid === false) {
      validationMessage = (
        <Text color="status-critical" size="small">
          (Opp. ID validation failed)
        </Text>
      );
    }

    return (
      <Layer onEsc={onClose} onClickOutside={onClose}>
        <Box pad="medium" width="large" gap="medium">
          <Heading level={3} margin="none" style={{ whiteSpace: "nowrap" }}>
            Create Voucher
          </Heading>

          {/* Dynamic Demo Selection UI Section */}
          <Box gap="small">
            <Text weight="bold" size="small">
              Select Target Demo:
            </Text>
            {isLoadingDemos ? (
              <Box direction="row" gap="small" align="center" pad="small">
                <Spinner size="small" />
                <Text size="small" color="dark-4">
                  Loading options...
                </Text>
              </Box>
            ) : demoError ? (
              <Text size="small" color="status-critical">
                {demoError}
              </Text>
            ) : (
              <Box
                border={{ color: "light-4" }}
                pad="small"
                round="xsmall"
                background="light-1"
              >
                <RadioButtonGroup
                  name="demoSelection"
                  options={demoOptions}
                  value={selectedDemoId}
                  onChange={this.handleDemoChange}
                  gap="xsmall"
                />
              </Box>
            )}
          </Box>
          {AltStatus}
          <Box gap="small">
            <Text weight="normal" size="small">
              Voucher Description:
            </Text>
            <TextArea
              placeholder="Voucher Description here..."
              value={this.state.voucherdescription}
              onChange={(event) =>
                this.handleVoucherDescription(event.target.value)
              }
            ></TextArea>
          </Box>
          <Box direction="row" align="center" gap="medium">
            <Text weight="normal" size="small">
              Voucher Validity Duration (In Days), starts from submit:
            </Text>
            <Box
              direction="row"
              align="center"
              border={{ color: "dark-3", size: "small" }}
              round="xsmall"
              width="small"
            >
              <Button
                icon={
                  <FormDown
                    size="medium"
                    color="dark-1"
                    style={{ strokeWidth: "3px" }}
                  />
                }
                onClick={this.decrementDuration}
                plain
                pad="small"
              />
              <TextInput
                value={duration}
                onChange={this.handleDurationChange}
                plain
                textAlign="center"
                style={{ width: "60px", padding: "4px", fontWeight: "bold" }}
              />
              <Button
                icon={
                  <FormUp
                    size="medium"
                    color="dark-1"
                    style={{ strokeWidth: "3px" }}
                  />
                }
                onClick={this.incrementDuration}
                plain
                pad="small"
              />
            </Box>
          </Box>

          <Box
            direction="row"
            align="end"
            gap="medium"
            background="light-2"
            pad="small"
            round="xsmall"
          >
            <Box fill="horizontal">
              {validationMessage}
              <FormField
                label="SalesForce Opp ID, Click on icon to validate"
                size="medium"
              >
                {/* The wrapper Box mimics the input frame but allows button clicks */}
                <Box
                  direction="row"
                  align="center"
                  background={noOpportunityId ? "light-4" : "white"}
                  border={{
                    color:
                      isOppIdValid === false ? "status-critical" : "light-4",
                  }}
                  round="xsmall"
                  pad={{ horizontal: "small" }}
                >
                  <TextInput
                    plain // Removes default styling so it integrates smoothly into the Box
                    placeholder="Enter Opportunity ID"
                    value={opportunityId}
                    onChange={this.handleOppIdChange}
                    disabled={noOpportunityId}
                    plain="full"
                    style={{ fontWeight: "normal" }}
                  />
                  <Box justify="center" pad={{ left: "small" }}>
                    <Button
                      icon={
                        isValidatingOpp ? (
                          <Spinner size="small" />
                        ) : isOppIdValid === true ? (
                          <FormCheckmark color="status-ok" />
                        ) : (
                          <SearchAdvanced
                            color={opportunityId.trim() ? "brand" : "dark-4"}
                          />
                        )
                      }
                      hoverIndicator={{ color: "light-3" }} // Creates a visual button highlight on hover
                      onClick={this.handleValidateOpportunity}
                      disabled={
                        !opportunityId.trim() ||
                        isValidatingOpp ||
                        noOpportunityId
                      }
                      tip={
                        opportunityId.trim()
                          ? "Click to validate Opportunity ID"
                          : "Enter an ID to validate"
                      }
                      a11yTitle="Validate Opportunity ID"
                      plain={false} // Gives it a subtle button boundary
                      style={{
                        borderRadius: "4px",
                        padding: "4px 8px",
                        transition: "all 0.2s ease-in-out",
                      }}
                    />
                  </Box>
                </Box>
              </FormField>
            </Box>
            <Box pad={{ bottom: "small" }}>
              <CheckBox
                label="No Opportunity ID available"
                checked={noOpportunityId}
                onChange={this.handleCheckboxChange}
              />
            </Box>
          </Box>

          <Box direction="row" gap="small" align="start" fill="horizontal">
            <Box fill="horizontal">
              <FormField
                label="Add voucher recipients (1 or more) , + sign to Add"
                error={errorMessage}
              >
                <TextInput
                  placeholder="Enter email address"
                  value={emailInput}
                  onChange={this.handleInputChange}
                />
              </FormField>
            </Box>
            <Button
              size="small"
              icon={<Add />}
              primary
              margin={{ top: "xsmall" }}
              onClick={this.handleAddEmail}
            />
          </Box>

          {emailList.length > 0 && (
            <Box direction="row" fill="horizontal">
              <Box
                fill="horizontal"
                height={{ max: "small" }}
                overflow="auto"
                border
              >
                <List data={emailList} pad="small">
                  {(datum, index) => (
                    <Box
                      direction="row"
                      align="center"
                      justify="between"
                      fill="horizontal"
                    >
                      <Text size="small" style={{ wordBreak: "break-all" }}>
                        {datum}
                      </Text>
                      <Button
                        icon={<Trash size="small" color="status-critical" />}
                        onClick={() => this.handleRemoveEmail(index)}
                        plain
                      />
                    </Box>
                  )}
                </List>
              </Box>
              <Box width="44px" />
            </Box>
          )}

          <Box
            direction="row"
            justify="center"
            gap="small"
            margin={{ top: "medium" }}
          >
            <Button label="Close" onClick={onClose} />
            <Button
              label="Submit"
              primary
              disabled={isFormInvalid || bsubmitLoader}
              onClick={this.handleSubmit}
            />
          </Box>
        </Box>
      </Layer>
    );
  }
}

export default VoucherPopup;
